// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"527":"973a89b8","4190":"973a89b8","5784":"973a89b8","8272":"973a89b8","9469":"7fae9e3e"}[chunkId] + ".css";
};